<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-group element-type-part element-with-heading" epub:type="part" id="part-1" role="doc-part">
<div class="heading heading-container-group heading-size-group heading-format-group heading-alignment-fixed heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-title-is-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-upper"><span class="element-number-term">PART</span> <span class="element-number-number">1</span></h1>
</div>
</div>
</div>
</div>
<div class="text" id="part-1-text">
<div class="alignment-block alignment-block-align-left">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left">“Half of the time I don't know what they're talking about; their jokes seem to relate to a past that everyone but me has shared. I'm a foreigner in the world and I don't understand the language.”</p>
<p class="alignment-block-content alignment-block-content-left"><i>― Jean Webster</i></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part001.vue?b996ada4